module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/mtotal2-2c4c7c8267aa5f22275c9aa1c4b2bec9.jpg";